export default __webpack_public_path__ + "static/media/pic21.2bd1b185.jpg";